import { Component, ElementRef, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { MatDialog, MatPaginator, MatSort } from '@angular/material';
import { Observable } from 'rxjs/Observable';
import { BlockUI, NgBlockUI } from 'ng-block-ui';
import { ActivatedRoute, Router } from '@angular/router';
import { fuseAnimations } from '../../../../../../core/animations';
import { AuthenticationService } from '../../../../../services/authentication/authentication.service';
import { DivisionService } from '../../../../../services/divisions/division.service';
import { ShiftService } from '../../../../../services/shifts/shift.service';
import { SweetAlertService } from '../../../../../services/sweet-alert/sweet-alert.service';
import { SchoolYearService } from '../../../../../services/schoool-year/school-year.service';
import { CourseYearService } from '../../../../../services/cour-years/course-year.service';
import { SchoolYear } from '../../../../../models/school-years/school-year';
import { FormBuilder } from '@angular/forms';
import { Location } from '@angular/common';
import { TranslationService } from '../../../../../services/translation/translation.service';
import { StaffDataSource } from './staff-data-source';
import { StaffDatabase } from './staff-database';
import { ConceptService } from '../../../../../services/concepts/concept.service';
import { ConceptDto } from '../../../../../models/concepts/concept-dto';
import { ProfessionalConceptService } from '../../../../../services/professional-concept/professional-concept.service';
import { ProfessionalConceptInput } from '../../../../../models/professional-concept/professional-concept-input';
import { environment } from '../../../../../../../environments/environment';
import { Md5 } from 'ts-md5/dist/md5';
import { TranslateService } from '@ngx-translate/core';

@Component({
    selector: 'fuse-edit-professional-concept',
    templateUrl: './edit-professional-concept.component.html',
    styleUrls: ['./edit-professional-concept.component.scss'],
    animations: fuseAnimations
})
export class EditProfessionalConceptComponent implements OnInit, OnDestroy {
    @BlockUI('tracker') blockUIList: NgBlockUI;

    @ViewChild(MatPaginator) paginator: MatPaginator;
    @ViewChild(MatSort) sort: MatSort;
    @ViewChild('filter') filter: ElementRef;

    dataSource: StaffDataSource | null;
    employeeDatabase;

    displayedColumns = [];

    public shiftsFilter: any[];
    public shiftsColumns: any[];
    confirmDialogRef: any;
    private sub: any;
    public schoolYear: SchoolYear = new SchoolYear();
    schoolYearId = -1;
    public data: any;
    public concepts: ConceptDto[];
    public shiftSelected = -1;
    private md5Original: any;

    constructor(private authenticationService: AuthenticationService,
                public dialog: MatDialog,
                private location: Location,
                public divisionService: DivisionService,
                public shiftService: ShiftService,
                private router: Router,
                private schoolYearService: SchoolYearService,
                private route: ActivatedRoute,
                private courseYearService: CourseYearService,
                private fb: FormBuilder,
                private translationService: TranslationService,
                private sweetAlertService: SweetAlertService,
                private conceptService: ConceptService,
                private translateService: TranslateService,
                private professionalConceptService: ProfessionalConceptService) {
    }

    ngOnInit(): void {
        this.blockUIList.start('Cargando datos...');
        this.shiftsFilter = [];
        this.shiftsColumns = [];
        this.schoolYear = new SchoolYear();
        this.data = this.route.snapshot.data;
        this.sub = this.route.params.subscribe(params => {
            this.schoolYearId = params['id'] !== undefined ? +params['id'] : -1;
        });
        Observable.combineLatest(
            this.conceptService.getAll(),
            this.shiftService.getAll(),
            this.schoolYearService.getById(this.schoolYearId),
        ).subscribe(([concepts, shifts, schoolYear]) => {
            this.concepts = concepts;
            this.shiftsColumns = shifts;
            this.shiftsFilter = shifts.map(e => {
                    return {Description: e.Description, Id: e.Id};
                }
            );
            this.shiftsFilter.unshift({Description: 'Todos', Id: -1});
            this.schoolYear = schoolYear;
            this.blockUIList.stop();


            this.displayedColumns = ['LastName'];
            // this.shiftsColumns.forEach(e => {
            //     this.displayedColumns.push(e.Id.toString());
            // });
            this.displayedColumns.push('Concept');
            this.displayedColumns.push('Actions');

            this.employeeDatabase = new StaffDatabase(this.professionalConceptService, this.shiftsColumns, this.schoolYearId, () => {
                const md5 = new Md5();
                this.md5Original = md5.appendStr(JSON.stringify(this.employeeDatabase.data)).end();
            });
            this.dataSource = new StaffDataSource(this.employeeDatabase, this.paginator, this.sort, this.shiftSelected);
            Observable.fromEvent(this.filter.nativeElement, 'keyup')
                .debounceTime(150)
                .distinctUntilChanged()
                .subscribe(() => {
                    if (!this.dataSource) {
                        return;
                    }
                    this.dataSource.filter = this.filter.nativeElement.value;
                });
        });

        if (this.data.mode === 'view') {

        }
    }


    ngOnDestroy(): void {
        this.sub.unsubscribe();
    }

    back() {
        this.location.back();
    }

    save() {
        this.blockUIList.start('Guardando datos...');
        const data = [];
        // this.shiftsColumns.forEach(e => {
        //     const filtered = this.employeeDatabase.data.filter(d => d[e.Id]);
        //     filtered.forEach(f => {
        //         const professionalConceptInput = new ProfessionalConceptInput();
        //         professionalConceptInput.ShiftId = e.Id;
        //         professionalConceptInput.ConceptId = f[e.Id];
        //         professionalConceptInput.EmployeeId = f.Id;
        //         professionalConceptInput.SchoolYearId = this.schoolYearId;
        //         data.push(professionalConceptInput);
        //     });
        // });

        const filtered = this.employeeDatabase.data.filter(d => d.ConceptId);
        filtered.forEach(f => {
            const professionalConceptInput = new ProfessionalConceptInput();
            professionalConceptInput.ConceptId = f.ConceptId;
            professionalConceptInput.EmployeeId = f.Id;
            professionalConceptInput.SchoolYearId = this.schoolYearId;
            data.push(professionalConceptInput);
        });

        this.professionalConceptService.add(data).subscribe(response => {
            if (response.ResultCode === 1) {
                this.translateService.get('LABELS.DATA_SAVED_CORRECTLY').subscribe(res => {
                    this.sweetAlertService.success('', res, () => {
                        const md5 = new Md5();
                        this.md5Original = md5.appendStr(JSON.stringify(this.employeeDatabase.data)).end();
                    });
                });
            } else {
                this.translationService.translate('ERRORS.ERROR_REQUEST', response.ResultMsg, (res: string) => {
                    this.sweetAlertService.error('Error', res, null);
                });
            }
            this.blockUIList.stop();
        }, error => {
            this.blockUIList.stop();
            this.translationService.translate('ERRORS.ERROR_REQUEST', error, (res: string) => {
                this.sweetAlertService.error('Error', res, null);
            });
        });
    }

    containShift(row, shiftId) {
        return row.Shifts.find(e => e.ShiftId === shiftId);
    }

    filterEmployees(shiftId: number) {
        this.dataSource.filterEmployee(shiftId);
        this.shiftSelected = shiftId;

        this.displayedColumns = ['LastName'];
        this.shiftsColumns.forEach(e => {
            if (e.Id === shiftId || shiftId === -1) {
                this.displayedColumns.push(e.Id.toString());
            }
        });
        this.displayedColumns.push('Actions');
    }

    print(employee) {
        // check changes
        const md5 = new Md5();
        const temp = md5.appendStr(JSON.stringify(this.employeeDatabase.data)).end();
        if (temp !== this.md5Original) {
            this.sweetAlertService.info('Error', 'Hay cambios sin guardar. Por favor guarde los cambios antes de Imprimir');
            return;
        }

        // check shifts
        // const shiftsByEmployee = employee.Shifts.map(s => s.ShiftId);
        // if (!shiftsByEmployee.length) {
        //     return;
        // }

        if (!employee.ConceptId) {
            return;
        }

        window.open(environment.backendUri + 'report/teachingProfesionalConcept/' + employee.Id + '/' + this.schoolYearId, '_new');
        // if (shiftsByEmployee.length === 1) {
        //     const concept = employee[shiftsByEmployee[0]];
        //     if (concept && concept > 0) {
        //         window.open(environment.backendUri + 'report/teachingProfesionalConcept/' + employee.Id + '/' + this.schoolYearId, '_new');
        //     } else {
        //         this.sweetAlertService.error('Error', 'No se cargó el concepto del turno ' + this.shiftsColumns.find(s => s.Id === shiftsByEmployee[0]).Description);
        //     }
        //     return;
        // }
        // const config: MatDialogConfig = {
        //     width: '400px',
        //     maxWidth: '400px',
        //     disableClose: true,
        //     data: {
        //         shifts: shiftsByEmployee,
        //         employee: employee,
        //         schoolYearId: this.schoolYearId
        //     }
        // };
        //
        // this.confirmDialogRef = this.dialog.open(PrintShiftComponent, config);
        // this.confirmDialogRef.afterClosed().subscribe(result => {
        //     console.log('FuseStudentsComponent > add > result', result);
        //     if (result !== true) {
        //
        //     }
        // });
    }

    printAll() {
        // check changes
        const md5 = new Md5();
        const temp = md5.appendStr(JSON.stringify(this.employeeDatabase.data)).end();
        if (temp !== this.md5Original) {
            this.sweetAlertService.info('Error', 'Hay cambios sin guardar. Por favor guarde los cambios antes de Imprimir');
            return;
        }
        window.open(environment.backendUri + 'report/teachingProfesionalConceptAll/' + this.schoolYearId, '_new');
    }
}



// WEBPACK FOOTER //
// ./src/app/main/content/pages/management/professional-concept/edit-professional-concept/edit-professional-concept.component.ts